import { render, staticRenderFns } from "./language-setting.vue?vue&type=template&id=43594311&scoped=true&"
import script from "./language-setting.vue?vue&type=script&lang=js&"
export * from "./language-setting.vue?vue&type=script&lang=js&"
import style0 from "./language-setting.vue?vue&type=style&index=0&id=43594311&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43594311",
  null
  
)

export default component.exports